import { useAppNavigation } from "src/contexts/AppNavigationContext";

import { FC } from 'react';
import { FontAwesomeIcon, FontAwesomeIcons } from 'src/constants/fontAwesomeIcons';

import './NavBurgerButton.scss';

const NavBurgerButton: FC = () => {
    const { isOpen, toggleDrawer: toggleNavigationDrawer } = useAppNavigation();

    

    return (
        <button
            className="nav-button-burger"
            onClick={() => {
                toggleNavigationDrawer(!isOpen)
            }}
            type="button"
            aria-label={isOpen ? "Close navigation" : "Open navigation"}
            aria-expanded={isOpen}
        >
            {
                isOpen ?
                <FontAwesomeIcon 
                    className="nav-button-burger-icon"
                    icon={FontAwesomeIcons.Regular.TIMES} 
                    fixedWidth
                /> :
                <FontAwesomeIcon 
                    className="nav-button-burger-icon"
                    icon={FontAwesomeIcons.Solid.HAMBURGER} 
                    fixedWidth
                />
            }
        </button>
    );
}


export default NavBurgerButton;
